// extracted by mini-css-extract-plugin
export var body = "_gg-0";
export var sectionHeader = "_gg-4";
export var shortcutColumns = "_gg-2";
export var shortcutList = "_gg-1";
export var shortcutSection = "_gg-3";